(() => {
  var ProductMakeOffer = (section) => {
    const sectionId = section && section.dataset.sectionId;
    let formatMoney = window.themeCore.utils.formatMoney;

    const selectors = {
      productForm: "[data-js-product-form]",
      makeOfferButton: ".js-make-offer-button",
      makeOfferPopup: ".js-make-offer-popup",
      makeOfferForm: ".js-make-offer-form",
      makeOfferProductPrice: ".js-make-offer-popup-price",
      makeOfferProductImage: ".js-make-offer-popup-image",
      makeOfferProductSKU: ".js-make-offer-popup-sku",
      makeOfferFormStatus: ".js-make-offer-form-status",
    };

    const cssClasses = {
      active: "is-active",
      isPosted: "is-posted",
      hidden: "is-hidden",
      isNotifyMeActive: "is-make-offer-popup-active",
    };

    const searchParams = {
      contactPosted: "contact_posted",
      contactMessage: "contact[body]",
      formType: "form_type",
    };

    const Toggle = window.themeCore.utils.Toggle;
    const on = window.themeCore.utils.on;

    let productForm = null;
    let makeOfferButton = null;
    let makeOfferPopup = null;
    let makeOfferForm = null;
    let makeOfferPopupToggle = null;
    let makeOfferFormStatus = null;
    let makeOfferFormId = null;
    let changeVariantIsFired = false;

    function init() {
      if (!section || !sectionId) {
        return false;
      }

      productForm = section.querySelector(selectors.productForm);
      makeOfferButton = section.querySelector(selectors.makeOfferButton);
      makeOfferPopup = section.querySelector(selectors.makeOfferPopup);

      if (!makeOfferPopup || !makeOfferButton) {
        return;
      }

      makeOfferForm = makeOfferPopup.querySelector(selectors.makeOfferForm);

      if (!productForm || !makeOfferForm) {
        return false;
      }

      makeOfferFormId = makeOfferForm.id;
      makeOfferFormStatus = makeOfferForm.querySelector(
        selectors.makeOfferFormStatus
      );

      if (!makeOfferFormStatus) {
        return;
      }

      initToggle();
      initFormStatus();
      setEventBusListeners();
    }

    function initToggle() {
      makeOfferPopupToggle = Toggle({
        toggleSelector: makeOfferPopup.id,
      });

      makeOfferPopupToggle.init();

      on("click", makeOfferPopup, function (e) {
        if (e.target == this) {
          makeOfferPopupToggle.close(makeOfferPopup);
        }
      });

      window.themeCore.EventBus.listen(
        `Toggle:${makeOfferPopup.id}:close`,
        closeMakeOfferPopup
      );
      window.themeCore.EventBus.listen(
        `Toggle:${makeOfferPopup.id}:open`,
        openMakeOfferPopup
      );
    }

    function initFormStatus() {
      if (isCurrentFormPosted()) {
        makeOfferForm.classList.add(cssClasses.isPosted);
        makeOfferPopupToggle.open(makeOfferPopup);
      }
    }

    function isCurrentFormPosted() {
      return (
        window.location.hash.includes(`#${makeOfferFormId}`) &&
        makeOfferFormStatus.dataset.formStatus === "posted"
      );
    }

    function closeMakeOfferPopup() {
      if (isCurrentFormPosted()) {
        setTimeout(() => {
          makeOfferForm.classList.remove(cssClasses.isPosted);
          section.classList.remove(cssClasses.isNotifyMeActive);
        }, 400);

        let newUrl = new URL(window.location.href);
        newUrl.hash = "";
        // Get the current URL
        newUrl.searchParams.delete(searchParams.contactPosted);
        newUrl.searchParams.delete(searchParams.contactMessage);
        newUrl.searchParams.delete(searchParams.formType);
        window.history.replaceState({}, null, newUrl.toString());
      }
    }

    function openMakeOfferPopup() {
      section.classList.add(cssClasses.isNotifyMeActive);
    }

    function setEventBusListeners() {
      window.themeCore.EventBus.listen(
        `form:${sectionId}:change-variant`,
        onChangeVariant
      );

      if (!changeVariantIsFired) {
        // product has only default variant
        const productElementJSON = section.querySelector(
          "[data-js-product-json]"
        );
        let productJSON;

        try {
          productJSON = JSON.parse(productElementJSON.innerText);
        } catch {
          productJSON = null;
        }

        if (!productJSON) {
          return;
        }

        if (productJSON.has_only_default_variant) {
          updatePopupImage(productJSON.variants[0]);
          updatePopupPrice(productJSON.variants[0]);
          updateSKU(productJSON.variants[0]);
        }
      }
    }

    function onChangeVariant({ currentVariant }) {
      changeVariantIsFired = true;

      updatePopupImage(currentVariant);
      updatePopupPrice(currentVariant);
      updateSKU(currentVariant);
    }

    function updatePopupImage(variant) {
      if (!variant) {
        return;
      }

      const popupImage = makeOfferPopup.querySelector(
        selectors.makeOfferProductImage
      );

      if (!popupImage || !variant.featured_image) {
        return;
      }

      popupImage.setAttribute(
        "src",
        `${variant.featured_image.src}&width=800&height=800`
      );
    }

    function updateSKU(variant) {
      const popupSKU = makeOfferPopup.querySelector(
        selectors.makeOfferProductSKU
      );

      if (!popupSKU) {
        return;
      }

      if (!variant) {
        popupSKU.value = "";
        return;
      }

      popupSKU.value = variant.sku;
    }

    function updatePopupPrice(variant) {
      const popupPrice = makeOfferPopup.querySelector(
        selectors.makeOfferProductPrice
      );

      if (!popupPrice) {
        return;
      }

      if (!variant) {
        popupPrice.classList.add(cssClasses.hidden);
        return;
      }

      popupPrice.classList.remove(cssClasses.hidden);

      const regularPrice = popupPrice.querySelector(
        ".js-make-offer-popup-regular-price"
      );
      const comparePrice = popupPrice.querySelector(
        ".js-make-offer-popup-compare-price"
      );

      const format = window.themeCore.objects.shop.money_format;
      const moneyPrice = formatMoney(variant.price, format);

      regularPrice.innerHTML = moneyPrice;

      if (variant.compare_at_price) {
        const moneyPriceOld = formatMoney(variant.compare_at_price, format);

        popupPrice.querySelector(".price").classList.add("price--on-sale");
        comparePrice.innerHTML = moneyPriceOld;
      } else {
        popupPrice.querySelector(".price").classList.remove("price--on-sale");
        comparePrice.innerHTML = "";
      }
    }

    return Object.freeze({
      init,
    });
  };

  var ProductAskExpert = (section) => {
    const sectionId = section && section.dataset.sectionId;
    let formatMoney = window.themeCore.utils.formatMoney;

    const selectors = {
      productForm: "[data-js-product-form]",
      makeOfferButton: ".js-ask-expert-button",
      makeOfferPopup: ".js-ask-expert-popup",
      makeOfferForm: ".js-make-offer-form",
      makeOfferProductPrice: ".js-make-offer-popup-price",
      makeOfferProductImage: ".js-make-offer-popup-image",
      makeOfferProductSKU: ".js-make-offer-popup-sku",
      makeOfferFormStatus: ".js-make-offer-form-status",
    };

    const cssClasses = {
      active: "is-active",
      isPosted: "is-posted",
      hidden: "is-hidden",
      isNotifyMeActive: "is-make-offer-popup-active",
    };

    const searchParams = {
      contactPosted: "contact_posted",
      contactMessage: "contact[body]",
      formType: "form_type",
    };

    const Toggle = window.themeCore.utils.Toggle;
    const on = window.themeCore.utils.on;

    let productForm = null;
    let makeOfferButton = null;
    let makeOfferPopup = null;
    let makeOfferForm = null;
    let makeOfferPopupToggle = null;
    let makeOfferFormStatus = null;
    let makeOfferFormId = null;
    let changeVariantIsFired = false;

    function init() {
      if (!section || !sectionId) {
        return false;
      }

      productForm = section.querySelector(selectors.productForm);
      makeOfferButton = section.querySelector(selectors.makeOfferButton);
      makeOfferPopup = section.querySelector(selectors.makeOfferPopup);

      if (!makeOfferPopup || !makeOfferButton) {
        return;
      }

      makeOfferForm = makeOfferPopup.querySelector(selectors.makeOfferForm);

      if (!productForm || !makeOfferForm) {
        return false;
      }

      makeOfferFormId = makeOfferForm.id;
      makeOfferFormStatus = makeOfferForm.querySelector(
        selectors.makeOfferFormStatus
      );

      if (!makeOfferFormStatus) {
        return;
      }

      initToggle();
      initFormStatus();
      setEventBusListeners();
    }

    function initToggle() {
      makeOfferPopupToggle = Toggle({
        toggleSelector: makeOfferPopup.id,
      });

      makeOfferPopupToggle.init();

      on("click", makeOfferPopup, function (e) {
        if (e.target == this) {
          makeOfferPopupToggle.close(makeOfferPopup);
        }
      });

      window.themeCore.EventBus.listen(
        `Toggle:${makeOfferPopup.id}:close`,
        closeMakeOfferPopup
      );
      window.themeCore.EventBus.listen(
        `Toggle:${makeOfferPopup.id}:open`,
        openMakeOfferPopup
      );
    }

    function initFormStatus() {
      if (isCurrentFormPosted()) {
        makeOfferForm.classList.add(cssClasses.isPosted);
        makeOfferPopupToggle.open(makeOfferPopup);
      }
    }

    function isCurrentFormPosted() {
      return (
        window.location.hash.includes(`#${makeOfferFormId}`) &&
        makeOfferFormStatus.dataset.formStatus === "posted"
      );
    }

    function closeMakeOfferPopup() {
      if (isCurrentFormPosted()) {
        setTimeout(() => {
          makeOfferForm.classList.remove(cssClasses.isPosted);
          section.classList.remove(cssClasses.isNotifyMeActive);
        }, 400);

        let newUrl = new URL(window.location.href);
        newUrl.hash = "";
        // Get the current URL
        newUrl.searchParams.delete(searchParams.contactPosted);
        newUrl.searchParams.delete(searchParams.contactMessage);
        newUrl.searchParams.delete(searchParams.formType);
        window.history.replaceState({}, null, newUrl.toString());
      }
    }

    function openMakeOfferPopup() {
      section.classList.add(cssClasses.isNotifyMeActive);
    }

    function setEventBusListeners() {
      window.themeCore.EventBus.listen(
        `form:${sectionId}:change-variant`,
        onChangeVariant
      );

      if (!changeVariantIsFired) {
        // product has only default variant
        const productElementJSON = section.querySelector(
          "[data-js-product-json]"
        );
        let productJSON;

        try {
          productJSON = JSON.parse(productElementJSON.innerText);
        } catch {
          productJSON = null;
        }

        if (!productJSON) {
          return;
        }

        if (productJSON.has_only_default_variant) {
          updatePopupImage(productJSON.variants[0]);
          updatePopupPrice(productJSON.variants[0]);
          updateSKU(productJSON.variants[0]);
        }
      }
    }

    function onChangeVariant({ currentVariant }) {
      changeVariantIsFired = true;
      console.log("22222");
      updatePopupImage(currentVariant);
      updatePopupPrice(currentVariant);
      updateSKU(currentVariant);
    }

    function updatePopupImage(variant) {
      if (!variant) {
        return;
      }

      const popupImage = makeOfferPopup.querySelector(
        selectors.makeOfferProductImage
      );

      if (!popupImage || !variant.featured_image) {
        return;
      }

      popupImage.setAttribute(
        "src",
        `${variant.featured_image.src}&width=800&height=800`
      );
    }

    function updateSKU(variant) {
      const popupSKU = makeOfferPopup.querySelector(
        selectors.makeOfferProductSKU
      );

      if (!popupSKU) {
        return;
      }

      if (!variant) {
        popupSKU.value = "";
        return;
      }

      popupSKU.value = variant.sku;
    }

    function updatePopupPrice(variant) {
      const popupPrice = makeOfferPopup.querySelector(
        selectors.makeOfferProductPrice
      );

      if (!popupPrice) {
        return;
      }

      if (!variant) {
        popupPrice.classList.add(cssClasses.hidden);
        return;
      }

      popupPrice.classList.remove(cssClasses.hidden);

      const regularPrice = popupPrice.querySelector(
        ".js-make-offer-popup-regular-price"
      );
      const comparePrice = popupPrice.querySelector(
        ".js-make-offer-popup-compare-price"
      );

      const format = window.themeCore.objects.shop.money_format;
      const moneyPrice = formatMoney(variant.price, format);

      regularPrice.innerHTML = moneyPrice;

      if (variant.compare_at_price) {
        const moneyPriceOld = formatMoney(variant.compare_at_price, format);

        popupPrice.querySelector(".price").classList.add("price--on-sale");
        comparePrice.innerHTML = moneyPriceOld;
      } else {
        popupPrice.querySelector(".price").classList.remove("price--on-sale");
        comparePrice.innerHTML = "";
      }
    }

    return Object.freeze({
      init,
    });
  };


function initialize(root) {
  root.querySelectorAll('[data-section-type="product"]').forEach(section => {
    if (section.dataset.glxInquiriesReady) return;
    section.dataset.glxInquiriesReady = 'true';
    ProductMakeOffer(section).init();
    ProductAskExpert(section).init();
  });
}
function ready() { if (window.themeCore && window.themeCore.utils) initialize(document); }
if (window.themeCore && window.themeCore.loaded) ready(); else document.addEventListener('theme:all:loaded', ready, {once:true});
document.addEventListener('shopify:section:load', ready);
})();
